<template>
  <layout-default>
    <div class="admin-panel-log">
      <v-overlay :value="loading" z-index="4">
        <v-progress-circular indeterminate size="64"></v-progress-circular>
      </v-overlay>
      <div class="mb-6">
        <v-btn
          rounded
          color="accent"
          elevation="0"
          target="_blank"
          @click="goToLogs"
          >Go back</v-btn
        >
      </div>
      <v-expansion-panels>
        <v-expansion-panel
          v-for="log in displayAdminLogs"
          :key="log.id"
          class="admin-panel-log__row"
        >
          <v-expansion-panel-header class="admin-panel-log__row-header">
            <div class="admin-panel-log__row-header-item entityId">
              <strong class="label">entityId</strong
              ><span>{{ log.entityId }}</span>
            </div>
            <div class="admin-panel-log__row-header-item dateTime">
              <strong class="label">dateTime</strong
              ><span>{{ log.dateTime }}</span>
            </div>
            <div class="admin-panel-log__row-header-item operation">
              <strong class="label">operation</strong
              ><span>{{ log.operation }}</span>
            </div>
            <div class="admin-panel-log__row-header-item tableName">
              <strong class="label">tableName</strong
              ><span>{{ log.tableName }}</span>
            </div>
            <div class="admin-panel-log__row-header-item id">
              <strong class="label">id</strong><span>{{ log.id }}</span>
            </div>
          </v-expansion-panel-header>
          <v-expansion-panel-content>
            <v-data-table
              :headers="headers"
              :items="log.data"
              :items-per-page="50"
              :header-props="{ sortIcon: 'bhi-menu-down' }"
              :disable-pagination="log.data.length === 0"
              class="elevation-1 state"
            >
              <template v-slot:body="{ items }">
                <tbody>
                  <template v-for="item in items">
                    <tr
                      :key="item.field"
                      :class="item.isDifferent ? 'state-different' : ''"
                    >
                      <td class="state-field">{{ item.field }}</td>
                      <td class="state-value">{{ item.oldState }}</td>
                      <td class="state-value">{{ item.state }}</td>
                    </tr>
                  </template>
                </tbody>
              </template>
            </v-data-table>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
    </div>
  </layout-default>
</template>

<script>
import { mapGetters, mapState, mapActions } from 'vuex'
import LayoutDefault from '@/layouts/LayoutDefault.vue'
import RouterMixin from '@/mixins/router'

export default {
  name: 'AdminPanelLogView',
  components: {
    LayoutDefault,
  },
  mixins: [RouterMixin],
  data() {
    return {
      headers: [
        { text: 'Field', value: 'field' },
        { text: 'Old State', value: 'oldState' },
        { text: 'State', value: 'state' },
      ],
    }
  },
  computed: {
    ...mapGetters('userStates', ['getRolename']),
    ...mapState('dictionariesStates', ['dictionaryBhUsersRoleIds']),
    ...mapState('adminLogsStates', ['adminLogs', 'loading']),
    displayAdminLogs() {
      const items = this.adminLogs || []
      const newItems = items.map(item => {
        const { data = {} } = item
        const { oldState = [], state = [] } = data
        const table = oldState.map(el => {
          const newState = state.find(newEl => newEl.field === el.field)
          return {
            field: el.field,
            oldState: el?.value || '',
            state: newState?.value || '',
            isDifferent: (el?.value || '') !== (newState?.value || ''),
          }
        })
        const restNewState = state
          .filter(el => !table.find(val => val.field === el.field))
          .map(el => ({
            field: el.field,
            oldState: '',
            state: el?.value || '',
            isDifferent: false,
          }))

        const newItemData = [...table, ...restNewState]
        return {
          ...item,
          data: newItemData,
        }
      })

      return newItems
    },
  },
  methods: {
    ...mapActions('adminLogsStates', ['getAdminLogs']),
    getData() {
      // redirect if cannot go to the dashboard OR no traceId
      if (
        this.dictionaryBhUsersRoleIds[this.getRolename] !== 1 &&
        !this.$route.params?.id
      ) {
        this.$router.push('/participants')
        return
      }

      this.getAdminLogs(this.$route.params?.id)
    },
    goToLogs() {
      this.$router.back()
    },
  },
}
</script>

<style lang="scss">
@import '@/styles/variables.scss';

.admin-panel-log {
  padding: 1.5 * $gutter $gutter 0 $gutter;
  &__row {
    &-header {
      margin-left: -$gutter * 0.5;
      margin-right: -$gutter * 0.5;

      &-item {
        padding-left: $gutter * 0.5;
        padding-right: $gutter * 0.5;

        .label {
          color: $bh-gray--2;
          display: inline-block;
          padding-bottom: 5px;
          width: 100%;
        }

        &.entityId {
          width: 150px;
          max-width: 150px;
        }
        &.dateTime {
          width: 200px;
          max-width: 200px;
        }
        &.operation {
          flex: 1;
        }
        &.tableName {
          flex: 1;
        }
        &.id {
          min-width: 200px;
          width: 250px;
          max-width: 300px;
        }
      }
    }
  }

  .state {
    &-different {
      background-color: $bh-gray--6;
    }
    &-field {
      width: 30%;
      min-width: 30%;
    }
    &-value {
      width: 35%;
      min-width: 35%;
    }
  }
}
</style>
